module.exports = __webpack_public_path__ + "img/18.0b633f44.webp";